module.exports = __webpack_public_path__ + "img/0f1dd1d.jpg";